import styled from 'styled-components';

import {
  spacingInlineMd,
  spacingInlineSm,
  spacingInlineXs,
} from '@useblu/ocean-tokens/web/tokens';

import { breakpointTo } from '@useblu/utils';

export const Wrapper = styled.main`
  width: 100%;
  height: 100%;
  min-height: 100dvh;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-x: hidden;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100%;
  padding: 0 ${spacingInlineSm};
  flex: 1;

  ${breakpointTo('bpMedium')} {
    flex-direction: column;
    justify-content: flex-start;

    padding: ${spacingInlineMd} ${spacingInlineXs};
    height: 100%;
  }
`;

export const LoadingContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;

  width: 100%;
  height: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  max-width: 100%;
  gap: ${spacingInlineMd};

  ${breakpointTo('bpMedium')} {
    flex-direction: column;
    justify-content: flex-start;

    flex: 1;
    width: 100%;
    height: 100%;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  justify-content: center;

  max-width: 70%;

  ${breakpointTo('bpMedium')} {
    flex-direction: column;
    justify-content: flex-start;

    flex: 1;
    height: 100%;
    max-width: 100%;
    padding: ${spacingInlineXs};
  }
`;

export const CardContainer = styled.div`
  display: flex;
  justify-content: center;

  ${breakpointTo('bpMedium')} {
    display: none;
  }
`;
